import TicketsNav from "../../components/Tickets/TicketsNav";
import Header from "../../components/Header/Header";
import { Globals as OldGlobals } from "../../global/Globals";
import NoResultsComponent from '../../components/NoResults/NoResult';
import Footer from "../../components/Footer/Footer";
import Loader from '../../components/Loader/Loader';
import Button from "../../components/Button/Button";
import "../../pages/Tickets/Tickets.css"
import { useEffect, useRef, useState } from "react";
import CheckboxDropDown from "../../components/CheckboxDropDown/CheckboxDropDown";
import TicketsCard from "../../components/TicketsCard/TicketsCard";
import { fetchProducerTickets, fetchCCTickets, fetchCETickets, fetchSystemAdminTickets } from "../../services/api";
import Pagination from "../../components/Pagination/Pagination";
import Search from "../../components/SearchBar/Search";
import { Link, useNavigate, useLocation } from "react-router-dom";
import CryptoUtils from "../../util/cryptoUtils";
import Toast from "../../components/Toast/Toast";
import { useRole } from "../../context/Rolecontext";
import { useCluster } from "../ClusterContext/ClusterContext";
import { useLanguage } from "../../context/Languagecontext";

export default function Tickets() {
    const location = useLocation();
    let parentName = location.state?.parentName;
    const { Globals ,languages, setLanguages } = useLanguage();
    const [NavLinkState, setNav] = useState ({
        FirstNavbar:"",
        SecondNavbar:Globals.FAQ_DROPDOWN.TICKETS,
        Title:Globals.FAQ_DROPDOWN.TICKETS,
        ParentTab: parentName,
    });
    const { toastValue, errorToastValue } = location.state || {};
    const NavLinkData= {FirstNavbar:Globals.TICKETS_PAGE.DASHBOARD,SecondNavbar:Globals.TICKETS_FILTER.TICKETS,Title:Globals.TICKETS_FILTER.TICKETS};
    const [activeTimeTab, setActivetimetab] = useState("Today");
    const [briefActiveTab, setBriefActiveTab] = useState("All");
    const [HalfPageData, setHalfPageData] = useState("");
    const [isHalfScreenPopupVisible, setIsHalfScreenPopupVisible] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(false);
    const [briefStatus, setbriefStatus] = useState(null);
    const dropdownRefs = useRef({}); // Store refs for dropdowns
    const [briefData, setBriefData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState(null);
    const [producerSearchQuery, setProducerSearchQuery] = useState(null);
    const [toast, setToast] = useState({open:false, status:'', title:""});
    const navigate = useNavigate();
    let btnClass = "btn-style";
    let paginationPageChange = () => {};
    const [clusterId, setClusterId] = useState();
    const { selectedClusters } = useCluster();
    const { selectedRole } = useRole();
    const [roleID, setroldId] = useState(CryptoUtils.getFromLocalStorage("roleId").toString());
    const isIntialRenderRole = useRef(true);
    const [dropdownState, setDropdownState] = useState({
        activeDropdown: null,
        dropdowns: {
            TICKET_TYPE: { options: [
                {id: 1, name: Globals.TICKET_TYPE.PROPOSAL },
                {id: 2, name: Globals.TICKET_TYPE.BRIEF },
                {id: 3, name: Globals.TICKETS_PAGE.OTHERS_TECHNICAL_ISSUE },
                {id: 4, name: Globals.TICKETS_PAGE.OTHERS_GENERAL_INQUIRY },
                {id: 5, name: Globals.TICKETS_PAGE.OTHERS_ACCOUNT_RELATED }
              ],
            selected: [], selectedText: [], isloading: false }
        }
    });
    const isInitialRenderPage = useRef(true);
    const isInitialRenderTab = useRef(true);
    const isInitialRenderCluster = useRef(true);
    const isInitialRenderSearch = useRef(true);

    const renderToast = (status,title) =>{
    setToast({open:true, status:status,title:title});
    setTimeout(() => {
        setToast({open:false, status:'',title:''});
        //below code is to remove recurring retained toast message
        const newState = { ...location.state };
        delete newState.toastValue;
        delete newState.errorToastValue;
  }, 4000);
}

    const handleBriefTabClick = (tab) => {
        setBriefActiveTab(tab);
        paginationPageChange(1);
    };

    const handletog = async (dropdownName) => {
        setActiveDropdown((prev) => (prev === dropdownName ? null : dropdownName));

        if (dropdownState.dropdowns[dropdownName].options.length === 0) {
        await fetchOptions(dropdownName);
        }
    };

    const fetchOptions = async (dropdownName) => {
        setDropdownState((prev) => ({
            ...prev,
            dropdowns: {
            ...prev.dropdowns,
            [dropdownName]: { ...prev.dropdowns[dropdownName], isLoading: true },
            },
        }));
    
        try {
          const filterData = dropdownState.dropdowns['TICKETTYPE'].options;
          // Simulate fetching options for each dropdown
          setDropdownState((prev) => ({
            ...prev,
            dropdowns: {
              ...prev.dropdowns,
              [dropdownName]: {
                ...prev.dropdowns[dropdownName],
                options: [...filterData],
                isLoading: false,
              },
            },
          }));
        } catch (error) {
          console.error("Error fetching options:", error);
          setDropdownState((prev) => ({
            ...prev,
            dropdowns: {
              ...prev.dropdowns,
              [dropdownName]: { ...prev.dropdowns[dropdownName], isLoading: false },
            },
          }));
        }
    };

      const handleSelectAll = (dropdownName, selectAll, options) => {
            setbriefStatus(null);
            const selectedDataString = options.map((option) => String(option.id));
            const selectedDataText = options.map((option) => String(option.name));

            setDropdownState((prev) => ({
                ...prev,
                dropdowns: {
                    ...prev.dropdowns,
                    [dropdownName]: {
                    ...prev.dropdowns[dropdownName],
                    selected: selectAll ? selectedDataString : [],
                    selectedText: selectAll ? selectedDataText : [],
                    },
                },
            }));
     };
     
     const handleSelect = (dropdownName, value) => {
        setbriefStatus(null);
        setDropdownState((prev) => {
        const dropdown = prev.dropdowns[dropdownName];
        if (!dropdown) return prev;

        const isSelected = dropdown.selected.includes(String(value.id));
        const inSelectedText = dropdown.selectedText.includes(String(value.name));

        const newSelected = isSelected
            ? dropdown.selected
                .filter((item) => item !== String(value.id))
                .map(String)
            : [
                ...dropdown.selected.filter((item) => item !== String(value.id)),
                String(value.id),
            ];

        const newSelectedText = inSelectedText
            ? dropdown.selectedText.filter((item) => item !== String(value.name)).map(String)
            : [
                ...dropdown.selectedText.filter((item) => item !== String(value.name)),
                String(value.name),
            ];

        return {
            ...prev,
            dropdowns: {
            ...prev.dropdowns,
            [dropdownName]: {
                ...dropdown,
                selected: newSelected,
                selectedText: newSelectedText,
            },
            },
        };
        });
    };

    const dropdownselected = Object.values(dropdownState?.dropdowns).some(
        (dropdown) => dropdown?.selected && dropdown?.selected.length > 0
    );
    const togglePopup = (data) => {
        setHalfPageData(data)
        setIsHalfScreenPopupVisible(!isHalfScreenPopupVisible);
    };

    useEffect(() => {
    if(parentName === "admin" || parentName === "internal_dashboard" || parentName === "dashboard") {
      parentName = "Dashboard"
    }  else if(parentName === "internal_management") {
      parentName = "Internal Management"
    } else if(parentName === "auditTrails") {
      parentName = "Audit Trails"
    } else {
      parentName === 'proposals' ? parentName = "My Proposals" : parentName = "All Proposals";
    }
    setNav(nav => ({
      ...nav,
      FirstNavbar: parentName
    }));
  }, [])

    //Role Change logic
  useEffect(() => {
    if (clusterId){
      setroldId(CryptoUtils.getFromLocalStorage("roleId").toString());
    }
  }, [selectedRole]);

  useEffect(() => {
    let filter;
    if(roleID === Globals.USER_ROLES.SNR_MGR){
        navigate(OldGlobals.NAVPATH.HOME, { state: { activeHeader: "internal_dashboard" } });
    }else {
        if(roleID === Globals.USER_ROLES.CC){
            filter = {
                ticketType: dropdownState.dropdowns.TICKET_TYPE.selected,
                ticketSearch: searchQuery ? searchQuery : "",
                producerSearch: producerSearchQuery ? producerSearchQuery : ""
            }
        } else if(roleID === Globals.USER_ROLES.PRODUCER){
            filter = {
                ticketType: dropdownState.dropdowns.TICKET_TYPE.selected,
                search: searchQuery ? searchQuery : "",
            }
        } else if(roleID === Globals.USER_ROLES.CE){
            filter = {
                ticketSearch: searchQuery ? searchQuery : "",
                producerSearch: producerSearchQuery ? producerSearchQuery : ""
            }
        }
        else if(roleID === Globals.USER_ROLES.ADMIN){
            filter = {
                ticketSearch: searchQuery ? searchQuery : "",
                producerSearch: producerSearchQuery ? producerSearchQuery : ""
            }
        }
        paginationPageChange(1);
        fetchBriefdata(briefActiveTab, activeTimeTab,filter, 1);
    }
  }, [roleID]);

  useEffect(() => {
    setDropdownState((prevState) => ({
      ...prevState,
      dropdowns: {
        ...prevState.dropdowns,
        TICKET_TYPE: {
          ...prevState.dropdowns.TICKET_TYPE,
          selected: [],
          selectedText: [],
          options:  [
                {id: 1, name: Globals.TICKET_TYPE.PROPOSAL },
                {id: 2, name: Globals.TICKET_TYPE.BRIEF },
                {id: 3, name: Globals.TICKETS_PAGE.OTHERS_TECHNICAL_ISSUE },
                {id: 4, name: Globals.TICKETS_PAGE.OTHERS_GENERAL_INQUIRY },
                {id: 5, name: Globals.TICKETS_PAGE.OTHERS_ACCOUNT_RELATED }
              ],
          isloading: false
        }
      }
    }));
      let filter;
        if(roleID === Globals.USER_ROLES.CC){
            filter = {
                ticketType: dropdownState.dropdowns.TICKET_TYPE.selected,
                ticketSearch: searchQuery ? searchQuery : "",
                producerSearch: producerSearchQuery ? producerSearchQuery : ""
            }
        } else if(roleID === Globals.USER_ROLES.PRODUCER){
            filter = {
                ticketType: dropdownState.dropdowns.TICKET_TYPE.selected,
                search: searchQuery ? searchQuery : "",
            }
        } else if(roleID === Globals.USER_ROLES.CE){
            filter = {
                ticketSearch: searchQuery ? searchQuery : "",
                producerSearch: producerSearchQuery ? producerSearchQuery : ""
            }
        }
        else if(roleID === Globals.USER_ROLES.ADMIN){
            filter = {
                ticketSearch: searchQuery ? searchQuery : "",
                producerSearch: producerSearchQuery ? producerSearchQuery : ""
            }
        }
          paginationPageChange(1);
          fetchBriefdata(briefActiveTab, activeTimeTab,filter, 1);
        
    }, [languages]); 

    useEffect(() => {
        const initialCluster = JSON.parse(CryptoUtils.getFromLocalStorage("clusterName"));
        if (initialCluster?.length > 0) {
            setClusterId(initialCluster[0].clusterId);
        }
        if (clusterId){
        let filter;
        if(roleID === Globals.USER_ROLES.CC){
            filter = {
                ticketType: dropdownState.dropdowns.TICKET_TYPE.selected,
                ticketSearch: searchQuery ? searchQuery : "",
                producerSearch: producerSearchQuery ? producerSearchQuery : ""
            }
        } else if(roleID === Globals.USER_ROLES.PRODUCER){
            filter = {
                ticketType: dropdownState.dropdowns.TICKET_TYPE.selected,
                search: searchQuery ? searchQuery : "",
            }
        } else if(roleID === Globals.USER_ROLES.CE){
            filter = {
                ticketSearch: searchQuery ? searchQuery : "",
                producerSearch: producerSearchQuery ? producerSearchQuery : ""
            }
        }
        else if(roleID === Globals.USER_ROLES.ADMIN){
            filter = {
                ticketSearch: searchQuery ? searchQuery : "",
                producerSearch: producerSearchQuery ? producerSearchQuery : ""
            }
        }
          paginationPageChange(1);
          fetchBriefdata(briefActiveTab, activeTimeTab,filter, 1);
    }
    const handleClickOutside = (event) => {
      // Check if the click is outside all dropdowns
      const isClickInsideDropdown = Object.values(dropdownRefs.current).some(
        (ref) => ref?.contains(event.target)
      );
      if (!isClickInsideDropdown) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(()=>{
    if(toastValue === Globals.RAISE_TICKET.SUBMIT_BTN_TOAST_SUCCESS_MSG){
        renderToast('success',toastValue)
    } else if(toastValue === Globals.RAISE_TICKET.RESOLVE_BTN_TOAST_SUCCESS_MSG){
        renderToast('success',toastValue)
    } else if(toastValue === Globals.TOAST_FAILURE){
        renderToast('error',toastValue)
    }
    },[toastValue])

    useEffect(() => {
        if (isInitialRenderTab.current) {
            isInitialRenderTab.current = false;
            return; // Skip on first render
        }
        const hasSelectedOptions = Object.values(dropdownState.dropdowns).some(
          (dropdown) => dropdown.selected.length >= 0
        );
        if (hasSelectedOptions) {
        let filter;
        if(roleID === Globals.USER_ROLES.CC){
            filter = {
                ticketType: dropdownState.dropdowns.TICKET_TYPE.selected,
                ticketSearch: searchQuery ? searchQuery : "",
                producerSearch: producerSearchQuery ? producerSearchQuery : ""
            }
        } else if(roleID === Globals.USER_ROLES.PRODUCER){
            filter = {
                ticketType: dropdownState.dropdowns.TICKET_TYPE.selected,
                search: searchQuery ? searchQuery : "",
            }
        } else if(roleID === Globals.USER_ROLES.CE){
            filter = {
                ticketSearch: searchQuery ? searchQuery : "",
                producerSearch: producerSearchQuery ? producerSearchQuery : ""
            }
        }
        else if(roleID === Globals.USER_ROLES.ADMIN){
            filter = {
                ticketSearch: searchQuery ? searchQuery : "",
                producerSearch: producerSearchQuery ? producerSearchQuery : ""
            }
        }
        paginationPageChange(1);
        fetchBriefdata(briefActiveTab, activeTimeTab,filter, 1);
        }
      }, [briefActiveTab, activeTimeTab, dropdownState]);

      useEffect(() => {
        if (isInitialRenderPage.current) {
            isInitialRenderPage.current = false;
            return; // Skip on first render
        }
        let filter;
        if(roleID === Globals.USER_ROLES.CC){
            filter = {
                ticketType: dropdownState.dropdowns.TICKET_TYPE.selected,
                ticketSearch: searchQuery ? searchQuery : "",
                producerSearch: producerSearchQuery ? producerSearchQuery : ""
            }
        } else if(roleID === Globals.USER_ROLES.PRODUCER){
            filter = {
                ticketType: dropdownState.dropdowns.TICKET_TYPE.selected,
                search: searchQuery ? searchQuery : "",
            }
        } else if(roleID === Globals.USER_ROLES.CE){
            filter = {
                ticketSearch: searchQuery ? searchQuery : "",
                producerSearch: producerSearchQuery ? producerSearchQuery : ""
            }
        } else if(roleID === Globals.USER_ROLES.ADMIN){
            filter = {
                ticketSearch: searchQuery ? searchQuery : "",
                producerSearch: producerSearchQuery ? producerSearchQuery : ""
            }
        }
        fetchBriefdata(briefActiveTab, activeTimeTab,filter, currentPage);
    }, [currentPage]);

    useEffect(() => {
    const newCluster = JSON.parse(CryptoUtils.getFromLocalStorage("clusterName"));
    if (newCluster) {
      setClusterId(newCluster[0].clusterId);
    }
  }, [selectedClusters]);

    useEffect(() => {
        if (isInitialRenderCluster.current) {
            isInitialRenderCluster.current = false;
            return; // Skip on first render
        }
        if (clusterId){
        let filter;
        if(roleID === Globals.USER_ROLES.CC){
            filter = {
                ticketType: dropdownState.dropdowns.TICKET_TYPE.selected,
                ticketSearch: searchQuery ? searchQuery : "",
                producerSearch: producerSearchQuery ? producerSearchQuery : ""
            }
        } else if(roleID === Globals.USER_ROLES.PRODUCER){
            filter = {
                ticketType: dropdownState.dropdowns.TICKET_TYPE.selected,
                search: searchQuery ? searchQuery : "",
            }
        } else if(roleID === Globals.USER_ROLES.CE){
            filter = {
                ticketSearch: searchQuery ? searchQuery : "",
                producerSearch: producerSearchQuery ? producerSearchQuery : ""
            }
        }
        else if(roleID === Globals.USER_ROLES.ADMIN){
            filter = {
                ticketSearch: searchQuery ? searchQuery : "",
                producerSearch: producerSearchQuery ? producerSearchQuery : ""
            }
        }
          paginationPageChange(1);
          fetchBriefdata(briefActiveTab, activeTimeTab,filter, 1);
    }
  }, [clusterId]);

    const fetchBriefdata = async (ticketType, activeTimeTab, Filters, pageNumber) => {
        try {
            if(roleID === Globals.USER_ROLES.PRODUCER){
                const response = await fetchProducerTickets(ticketType, activeTimeTab, Filters, pageNumber);
                setBriefData(response.data.content);
                setbriefStatus(response.status);
            } else if(roleID === Globals.USER_ROLES.CC && clusterId) {
                const response = await fetchCCTickets(ticketType, activeTimeTab, Filters, pageNumber, clusterId);
                setBriefData(response.data.content);
                setbriefStatus(response.status);
            } else if(roleID === Globals.USER_ROLES.ADMIN) {
                const response = await fetchSystemAdminTickets(ticketType, activeTimeTab, Filters, pageNumber);
                setBriefData(response.data.content);
                setbriefStatus(response.status);
            }
            if(roleID === Globals.USER_ROLES.CE && clusterId) {
                const response = await fetchCETickets(ticketType, activeTimeTab, Filters, pageNumber, clusterId);
                setBriefData(response.data.content);
                setbriefStatus(response.status);
            }
            
        } catch (error) {
            console.error("Error in fetching brief info", error);
        }
    };

    const onPageChange = (pageNumber, setPage = () => {}) => {
      setCurrentPage(pageNumber);
      paginationPageChange = setPage;
    };
      
    const handleTimeTabClick = (data) => {
        setActivetimetab(data);
    };

    const handleSearch = (term) => {
       setSearchQuery(term);
    };

    const handleProducerSearch = (item) => {
        setProducerSearchQuery(item);
     }
    useEffect(() => {
        if (isInitialRenderSearch.current) {
            isInitialRenderSearch.current = false;
            return; // Skip on first render
        }
    let filter;
    if(roleID === Globals.USER_ROLES.CC){
            filter = {
                ticketType: dropdownState.dropdowns.TICKET_TYPE.selected,
                ticketSearch: searchQuery ? searchQuery : "",
                producerSearch: producerSearchQuery ? producerSearchQuery : ""
            }
        } else if(roleID === Globals.USER_ROLES.PRODUCER){
            filter = {
                ticketType: dropdownState.dropdowns.TICKET_TYPE.selected,
                search: searchQuery ? searchQuery : "",
            }
        } else if(roleID === Globals.USER_ROLES.CE){
            filter = {
                ticketSearch: searchQuery ? searchQuery : "",
                producerSearch: producerSearchQuery ? producerSearchQuery : ""
            }
        }
        else if(roleID === Globals.USER_ROLES.ADMIN){
            filter = {
                ticketSearch: searchQuery ? searchQuery : "",
                producerSearch: producerSearchQuery ? producerSearchQuery : ""
            }
        }
    fetchBriefdata(briefActiveTab, activeTimeTab,filter, currentPage);
  }, [searchQuery, producerSearchQuery])

    return(
        <div className="dashboard">
            <div className="Background-Page">
                <Header route="Tickets"/>
                <div className="Main">
                <TicketsNav props={NavLinkState} />
                {roleID === Globals.USER_ROLES.PRODUCER &&<Button title={Globals.TICKETS_PAGE.RAISE_A_TICKET} additionalStyle={btnClass}
                    action={() => {
                        navigate(OldGlobals.NAVPATH.RAISE_TICKET);
                    }}
                />}
                {roleID === Globals.USER_ROLES.PRODUCER &&<div className="note-text">
                    {Globals.TICKETS_PAGE.TICKET_NOTE_TEXT.split('FAQ').map((part, index, arr) =>
                                        index < arr.length - 1 ? (
                                          <span key={index}>
                                            {part}
                                            <Link className="cursor" to={OldGlobals.NAVPATH.FAQ}>{Globals.FAQ_DROPDOWN.FAQ}</Link>
                                          </span>
                                        ) : (
                                          <span key={index}>{part}</span>
                                        )
                                    )}
                    </div>}
                <div className="tickets-details">
                    <div className="tickets-details-tabs">
                        <div
                        className={`tickets-details-tab ${
                            briefActiveTab === "All" ? "active" : ""
                        }`}
                        onClick={() => handleBriefTabClick("All")}
                        >
                        {Globals.TICKETS_STATUS.ALL}
                        </div>
                        <div
                        className={`tickets-details-tab ${
                            briefActiveTab === "Active" ? "active" : ""
                        }`}
                        onClick={() => handleBriefTabClick("Active")}
                        >
                        {Globals.TICKETS_STATUS.ACTIVE}
                        </div>
                        <div
                        className={`tickets-details-tab ${
                            briefActiveTab === "Resolved" ? "active" : ""
                        }`}
                        onClick={() => handleBriefTabClick("Resolved")}
                        >
                        {Globals.TICKETS_STATUS.RESOLVED}
                        </div>
                    </div>
                    <div className="tickets-filters">
                        {roleID !== Globals.USER_ROLES.CE && roleID !== Globals.USER_ROLES.ADMIN &&<CheckboxDropDown
                            isOpen={activeDropdown === "TICKET_TYPE"}
                            options={dropdownState.dropdowns.TICKET_TYPE.options}
                            onToggle={() => handletog("TICKET_TYPE")}
                            onSelectAll={(selectAll, options) =>
                            handleSelectAll("TICKET_TYPE", selectAll, options)
                            }
                            onSelect={(value) => {
                            handleSelect("TICKET_TYPE", value);
                            }}
                            selectedValues={dropdownState.dropdowns.TICKET_TYPE.selected}
                            title={Globals.TICKETS_FILTER.TICKETS}
                            isDatePicker={false}
                            dropdownRef={(el) => (dropdownRefs.current["Ticket Type"] = el)}
                            selectedItems={dropdownState.dropdowns.TICKET_TYPE.selectedText}
                            isCreatedBy={false}
                        />}
                         {(roleID === Globals.USER_ROLES.CC || roleID === Globals.USER_ROLES.ADMIN || roleID === Globals.USER_ROLES.CE) &&<Search
                        onSearch={handleProducerSearch}
                        searchedFor={producerSearchQuery}
                        placeholder={Globals.TICKETS_DETAIL.PRODUCER}
                        />}
                        <Search
                        onSearch={handleSearch}
                        searchedFor={searchQuery}
                        placeholder={Globals.TICKETS_DETAIL.TICKET_NO}
                        />
                        <div className="ticket-date-timetabs">
                            <div
                            className={`date-overview-tab ${
                                activeTimeTab === "Today" ? "active" : ""
                            }`}
                            onClick={() => handleTimeTabClick("Today")}
                            >
                            {Globals.TICKETS_STATUS.TODAY}
                            </div>
                            <div
                            className={`date-overview-tab ${
                                activeTimeTab === "OneWeek" ? "active" : ""
                            }`}
                            onClick={() => handleTimeTabClick("OneWeek")}
                            >
                            {Globals.TICKETS_STATUS.ONEWEEK}
                            </div>
                            <div
                            className={`date-overview-tab ${
                                activeTimeTab === "OneMonth" ? "active" : ""
                            }`}
                            onClick={() => handleTimeTabClick("OneMonth")}
                            >
                            {Globals.TICKETS_STATUS.ONEMONTH}
                            </div>
                            <div
                            className={`date-overview-tab ${
                                activeTimeTab === "SixMonths" ? "active" : ""
                            }`}
                            onClick={() => handleTimeTabClick("SixMonths")}
                            >
                            {Globals.TICKETS_STATUS.SIXMONTHS}
                            </div>
                            <div
                            className={`date-overview-tab ${
                                activeTimeTab === "OneYear" ? "active" : ""
                            }`}
                            onClick={() => handleTimeTabClick("OneYear")}
                            >
                            {Globals.TICKETS_STATUS.ONEYEAR}
                            </div>
                            <div
                            className={`date-overview-tab ${
                                activeTimeTab === "All" ? "active" : ""
                            }`}
                            onClick={() => handleTimeTabClick("All")}
                            >
                            {Globals.TICKETS_STATUS.GREATERTHANONEYEAR}
                            </div>
                        </div>
                    </div>
                    <div className="cards-container">
                        {briefData?.ticketCardDto && briefData?.ticketCardDto.length > 0 ? (
                            briefData?.ticketCardDto?.map((card, index) => (
                            <TicketsCard key={index} data={card} togglePopup={togglePopup} />
                            ))
                        ) : briefStatus ? (
                            <div className="no-data">
                            <NoResultsComponent
                                data={{
                                message: dropdownselected
                                    ? Globals.NO_RESULTS_MESSAGE
                                    : Globals.NO_DATA_WITHOUTFILTER,
                                img: dropdownselected ? Globals.NO_RESULTS_IMG : Globals.NO_DATA_FOUND_IMG,
                                submessage: dropdownselected ? Globals.NO_RESULTS_DASHBOARD_MESSAGE : "",
                                }}
                            />
                            </div>
                        ) : (
                            <Loader height={50} width={50} component={"Dashboard"} />
                        )}
                    </div>
                    <div className="pagination-container">
                      {briefData?.ticketCardDto && briefData?.ticketCardDto.length > 0 && (
                        <Pagination
                          totalPages={Math.ceil(
                            briefData?.totalPageCount / Globals.MAX_COUNT.ACTIVE_BRIEF_COUNT
                          )}
                          currentPage={currentPage}
                          onPageChange={onPageChange}
                        />
                      )}
                    </div>
                </div>
                </div>

                <Footer />
            </div>
            {toast.open && <Toast status={toast.status} onClose={()=>{setToast({open:false, status:'', title:''});}} title={toast.title} />}
        </div>
    )
}